import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile';
import { faFileImage } from '@fortawesome/pro-regular-svg-icons/faFileImage';
import { faFilePdf } from '@fortawesome/pro-regular-svg-icons/faFilePdf';
import { faFileZipper } from '@fortawesome/pro-regular-svg-icons/faFileZipper';
import { faFileVideo } from '@fortawesome/pro-regular-svg-icons/faFileVideo';
import { faFilePowerpoint } from '@fortawesome/pro-regular-svg-icons/faFilePowerpoint';
import { faFileExcel } from '@fortawesome/pro-regular-svg-icons/faFileExcel';
import { faFileWord } from '@fortawesome/pro-regular-svg-icons/faFileWord';
import { faFileLines } from '@fortawesome/pro-regular-svg-icons/faFileLines';
import { faFileAudio } from '@fortawesome/pro-regular-svg-icons/faFileAudio';
import { faFileCode } from '@fortawesome/pro-regular-svg-icons/faFileCode';

// The same grouping the Angular FileTypeIcon service applied, with the icons that replace the
// Font Awesome 5 names it returned: fa-file-archive is now faFileZipper and fa-file-alt is
// faFileLines.
const ICONS_BY_TYPE: Record<string, IconDefinition> = {
    jpg: faFileImage,
    jpeg: faFileImage,
    png: faFileImage,
    bmp: faFileImage,
    svg: faFileImage,
    gif: faFileImage,
    psd: faFileImage,
    sketch: faFileImage,
    ai: faFileImage,
    pdf: faFilePdf,
    zip: faFileZipper,
    rar: faFileZipper,
    avi: faFileVideo,
    wmv: faFileVideo,
    mpg: faFileVideo,
    wma: faFileVideo,
    mov: faFileVideo,
    mkv: faFileVideo,
    mpeg: faFileVideo,
    ppt: faFilePowerpoint,
    pptx: faFilePowerpoint,
    xls: faFileExcel,
    xlsx: faFileExcel,
    doc: faFileWord,
    docx: faFileWord,
    txt: faFileLines,
    csv: faFileLines,
    wav: faFileAudio,
    mp3: faFileAudio,
    htm: faFileCode,
    html: faFileCode,
    css: faFileCode,
    js: faFileCode,
    rb: faFileCode,
    py: faFileCode,
    cpp: faFileCode,
    r: faFileCode,
};

function iconForFileType(type: string | null | undefined): IconDefinition {
    return ICONS_BY_TYPE[(type || '').toLowerCase()] || faFile;
}

// The file type beside a resource's filetype field, as the Angular input group addon showed it.
export default function FileTypeIcon({ type }: { type: string | null | undefined }) {
    return <FontAwesomeIcon icon={iconForFileType(type)} />;
}
